// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--20ik8";
export var Form = "styles-module--Form--xvrF2";
export var Notice = "styles-module--Notice--X7Dkz";